export default __webpack_public_path__ + "static/media/sold-out.68ec7d09.png";